const initial_result_data = {
  finish: false,
  loading: false,
  error: false,
  response: undefined,
  errortext: undefined,
  finishtime: undefined,
};

export default initial_result_data;
